import React from "react";
import { View, StyleSheet } from "react-native";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomTextInput from "../../common/general/CustomTextInput/CustomTextInput";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import DatePickerButton from "../../general/DatePickerButton/DatePickerButton";
import CustomDropdown from "../../common/general/CustomDropDown/CustomDropdown";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";

function TaskForm({
  title,
  description,
  startDate,
  onChangeTitle,
  onChangeDescription,
  onDatePick,
  onSubmit,
  onCancel,
  isEdit,
  workspaceOptions,
  selectedWorkspaceId,
  onWorkspaceChange,
}) {
  const { isMedium } = useResponsiveScreen();
  const inputLabelTextType = "text";
  const inputLabelTextSize = "s";
  const inputLabelTextColor = isMedium ? {} : { color: "#182230" };

  return (
    <View style={isMedium ? styles.container : {}}>
      <CustomText
        text="To-Do Name"
        size={inputLabelTextSize}
        textType={inputLabelTextType}
        style={inputLabelTextColor}
        weight="ultraBold"
        role="header"
        aria-level="2"
      />
      <CustomSpacing type="vertical" size="s" />
      <CustomTextInput
        placeholder={"e.g., Study for Exam"}
        autoFocus={true}
        required
        value={title}
        onChangeText={(text) => onChangeTitle(text)}
        aria-label="Task Title"
      />
      <CustomSpacing type="vertical" size="m" />
      <CustomText
        text="Description"
        size={inputLabelTextSize}
        textType={inputLabelTextType}
        style={inputLabelTextColor}
        weight="ultraBold"
        role="header"
        aria-level="2"
      />
      <CustomSpacing type="vertical" size="s" />
      <CustomTextInput
        placeholder={"Add details about this to-do..."}
        multiline
        maxLength={90}
        numberOfLines={4}
        value={description}
        onChangeText={(text) => onChangeDescription(text)}
        aria-label="Task Description"
      />
      <CustomSpacing type="vertical" size="m" />
      <CustomText
        text="Due Date"
        size={inputLabelTextSize}
        textType={inputLabelTextType}
        style={inputLabelTextColor}
        weight="ultraBold"
        role="header"
        aria-level="2"
      />
      <CustomSpacing type="vertical" size="xs" />
      <DatePickerButton date={startDate.toLocaleDateString()} onPress={onDatePick} />

      <CustomSpacing type="vertical" size="m" />
      <CustomText
        text="Workspace (Optional)"
        size={inputLabelTextSize}
        textType={inputLabelTextType}
        style={inputLabelTextColor}
        weight="ultraBold"
        role="header"
        aria-level="2"
      />
      <CustomSpacing type="vertical" size="xs" />
      <CustomDropdown
        disabled={workspaceOptions.length === 0}
        options={workspaceOptions}
        value={selectedWorkspaceId}
        onChange={onWorkspaceChange}
        openUpward={true}
      />

      <CustomSpacing type="vertical" size="m" />

      <View style={isMedium ? styles.buttonWrapper : {}}>
        <CustomButton
          text={"Cancel"}
          styleType="transparent"
          onPress={onCancel}
          textStyle={isMedium ? {} : { fontSize: 14 }}
          bold={!isMedium}
          aria-label={"Cancel"}
        />
        <CustomSpacing type="horizontal" size="m" />
        <CustomButton
          text={isEdit ? "Update To-Do" : "Create To-Do"}
          styleType="primary"
          onPress={onSubmit}
          textStyle={isMedium ? {} : { fontSize: 14 }}
          bold={!isMedium}
          aria-label={isEdit ? "Update To-Do" : "Create To-Do"}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 15,
    marginHorizontal: 3,
    paddingHorizontal: 3,
  },
  buttonWrapper: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
});

export default TaskForm;
